import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import {Stack, Typography} from "@mui/material";
import {SurveyAnswerSentiment} from "crqlar-react-common/dist/models/survey/surveySubmission.model";
import {useTranslation} from "react-i18next";
import {NEGATIVE_COLOR, POSITIVE_COLOR} from "../../insights/kit/insightsColors";
import {useInsightsFormatters} from "../../insights/kit/insightsFormat";

const SENTIMENTS: Record<SurveyAnswerSentiment, {label: string; color: string}> = {
    [SurveyAnswerSentiment.POSITIVE]: {label: 'Positive', color: POSITIVE_COLOR},
    [SurveyAnswerSentiment.NEUTRAL]: {label: 'Neutral', color: 'text.secondary'},
    [SurveyAnswerSentiment.NEGATIVE]: {label: 'Negative', color: NEGATIVE_COLOR},
};

interface Props {
    id?: string
    sentiment?: SurveyAnswerSentiment | null
    score?: number | null
}

/** The selected comment's server-provided contribution to its question's score. */
export default function SurveyEvaluationCommentRating({id, sentiment, score}: Props) {
    const {t} = useTranslation();
    const {whole} = useInsightsFormatters();
    const reading = sentiment != null && score != null ? SENTIMENTS[sentiment] : undefined;

    return (
        <Stack component={'span'} id={id} direction={'row'} alignItems={'center'} gap={0.5} sx={{color: reading?.color ?? 'text.secondary', minWidth: 0}}>
            <AutoAwesomeIcon titleAccess={t('Read from comments')} sx={{fontSize: 12, flexShrink: 0}}/>
            <Typography component={'span'} variant={'body2'} color={'inherit'} sx={{fontWeight: 500}}>
                {reading ? `${t(reading.label)} · ${whole(score!)} / 100` : t('Not read yet')}
            </Typography>
        </Stack>
    );
}
